<template>
  <div class="kopf" :class="{ 'bg-turkis': einkauf }">
    <notifications></notifications>
    <div class="container-fluid" :style="systemColor()">
      <div class="left-buttons" style="z-index: 5">
        <div class="navbar-button">
          <router-link to="/">
            <font-awesome-icon icon="fa-duotone fa-home" />
            <span>{{ $t("global.home") }}</span>
          </router-link>
        </div>
        <div class="navbar-button">
          <div class="clickable" @click="$router.go(-1)">
            <font-awesome-icon icon="fa-regular fa-angle-left" size="lg" />
            <span>{{ $t("global.back") }}</span>
          </div>
        </div>
        <div class="navbar-button">
          <div class="clickable" @click="$router.go(1)">
            <font-awesome-icon icon="fa-regular fa-angle-right" size="lg" />
            <span>{{ $t("global.forward") }}</span>
          </div>
        </div>
        <div class="navbar-button">
          <a href="#" @click="handleRefresh()">
            <font-awesome-icon icon="fa-regular fa-sync" />
            <span>{{ $t("global.refresh") }}</span>
          </a>
        </div>
      </div>
      <div class="HeaderTitle text-left ml-5" style="padding-left: 150px">
        <span> {{ $CONST("CONFIG").APPNAME }}</span>
        <span style="font-size: 14px; padding-left: 10px"
          >{{ appVersion }}
        </span>
      </div>
      <div class="right-buttons">
        <div
          class="navbar-button"
          v-if="
            berechtigungen.m_geschaeftspartner.read &&
            !isDozent &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <router-link to="/geschaeftspartner/personenliste">
            <font-awesome-icon icon="fa-duotone fa-user-friends" />
            <span>{{ $t("global.people") }}</span>
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-if="
            berechtigungen.m_geschaeftspartner.read &&
            !isDozent &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <router-link to="/geschaeftspartner/firmenliste">
            <font-awesome-icon icon="fa-duotone fa-building" />
            <span>{{ $t("global.navbar_companies") }}</span>
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-if="
            berechtigungen.m_finanzen.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <router-link :to="{ name: 'auftraege' }">
            <font-awesome-icon icon="fa-duotone fa-file-invoice-dollar" />
            <span>{{ $t("global.navbar_invoices") }}</span>
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-if="
            berechtigungen.m_korrespondenz.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <router-link :to="{ name: 'korrespondenz-liste' }">
            <font-awesome-icon icon="fa-duotone fa-print" />
            <span>{{ $t("global.navbar_correspondence") }}</span>
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-if="
            berechtigungen.m_korrespondenz.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <router-link :to="{ name: 'mail-liste' }">
            <font-awesome-icon icon="fa-duotone fa-envelope-open-text" />
            <span>{{ $t("global.emails") }}</span>
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-if="
            berechtigungen.m_anmeldungen.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA' &&
            (baseURL === 'https://skjv.bx-education.ch' || 'https://skjv-dev.bx-education.ch' || 'https://skjv-test.bx-education.ch')
          "
        >
          <router-link :to="{ name: 'anmeldungen-liste-skjv' }">
            <font-awesome-icon icon="fa-duotone fa-sign-in-alt" />
            <span>{{ $t("global.navbar_registrations") }}</span>
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-else-if="
            berechtigungen.m_anmeldungen.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA' &&
            !(baseURL === 'https://skjv.bx-education.ch' || 'https://skjv-dev.bx-education.ch' || 'https://skjv-test.bx-education.ch')
          "
        >
          <router-link :to="{ name: 'anmeldungen-liste' }">
            <font-awesome-icon icon="fa-duotone fa-sign-in-alt" />
            <span>{{ $t("global.navbar_registrations") }}</span>
          </router-link>
        </div>

        <div class="usersign" style="padding-left: 10px; top: 11px"></div>

        <SwitchLanguage />

        <div class="navbar-button">
          <a :href="noHelpAvailable ? noHelpURL : helpURL" target="_blank">
            <font-awesome-icon icon="fa-duotone fa-question-circle" />
            <span>{{ $t("global.help") }}</span>
          </a>
        </div>

        <div
          class="navbar-button"
          v-if="
            berechtigungen.g_einstellungen.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <router-link to="/einstellungen/dashboard">
            <font-awesome-icon icon="fa-duotone fa-sliders-v-square" />
            <span>{{ $t("global.settings") }}</span>
          </router-link>
        </div>

        <div class="navbar-button">
          <div class="clickable" @click="logout()">
            <font-awesome-icon icon="fa-duotone fa-door-open" />
            <span>{{ $t("global.logout") }}</span>
          </div>
        </div>

        <div class="usersign" style="padding-left: 25px; top: 11px">
          <div class="dropdown show">
            <a
              href=""
              title="Profil"
              class="none-decoration"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <font-awesome-icon
                aria-hidden="true"
                icon="fa-duotone fa-user"
                style="margin-bottom: 0.35rem"
                size="2x"
              />
              <span>{{ name }}</span>
            </a>
            <div
              class="dropdown-menu"
              style="
                background-color: #124862;
                margin-left: 0px;
                margin-top: 5px;
                border-radius: 0 0 5px 5px;
              "
              aria-labelledby="dropdownMenuLink"
            >
              <a
                href=""
                class="dropdown-item"
                data-toggle="modal"
                data-target="#passwort-aendern-modal"
              >
                <span>{{ $t("global.passwordchange") }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <passwort-aendern-modal
      id="passwort-aendern-modal"
      @success="showSuccessNotification"
    >
    </passwort-aendern-modal>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import server from "../server";
import PasswortAendernModal from "@/components/Modals/PasswortAendernModal";
import SwitchLanguage from "@/components/SwitchLanguage.vue";
import helpUrlMap from "../mixins/helpUrlMap";
import packageJson from "../../package.json";

export default {
  name: "Navbar",
  components: {
    PasswortAendernModal,
    SwitchLanguage,
  },
  mixins: [helpUrlMap],
  props: {
    icon: { type: String, default: null },
    einkauf: { type: Boolean, default: false },
    finanzen: { type: Boolean, default: false },
    erinnerungConfig: {
      type: Object,
      default: () => {
        return { url: "", titel: "" };
      },
    },
    docsName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      noHelpAvailable: false,
      baseURL: this.$CONST("CONFIG").BASEURL,
      isDozent: false,
      appVersion: packageJson.version,
    };
  },
  store,
  computed: {
    name() {
      return this.$store ? this.$store.getters.name : "";
    },
    artikeltypen() {
      return this.$store.state.artikeltypen;
    },
    logoutUrl() {
      if (process.env.NODE_ENV === "development") {
        return `${server.url}/logout/`;
      } else {
        return "/logout/";
      }
    },
    helpURL() {
      if (this.docsName && this.docsName in this.helpUrlMap) {
        return this.helpUrlMap[this.docsName];
      } else {
        return this.noHelpURL;
      }
    },
  },
  created() {
    if (
      this.gruppen.find(
        (gruppe) =>
          gruppe.id == this.$CONST("GRUPPEN").INSTRUCTOR ||
          gruppe.id == "1774DD1D796" // Dozentengruppe
      )
    )
      this.isDozent = true;
  },
  methods: {
    async logout() {
      try {
        await axios.post(this.logoutUrl, {});
        window.location.href = "/";
      } catch (error) {
        console.log(error);
      }
    },
    showSuccessNotification() {
      this.$notify({
        type: "success",
        title: this.$t("global.actionsuccessful"),
        text: this.$t("global.thepasswordhasbeenchanged"),
      });
    },
    systemColor() {
      switch (this.$CONST("CONFIG").ENVIRONMENT) {
        case "DEV":
          return "background-color: #341C57";
        case "TEST":
          return "background-color: #1c6c65";
        default:
          return "background-color: #124862";
      }
    },
    handleRefresh() {
      // aktuellen Pfad neu laden
      window.location.reload(true);
    },
  },
};
</script>

<style lang="scss">
.bm-item-list {
  margin-left: 5%;
}
</style>
